import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import styles from './Register.module.css';
import { FormikTextField } from '../../components/form-components/common-components/text-field/FormikTextField';
import { useStore } from '../../hooks/useStore';
import KaldenLogo from '../../assets/kalden-logo.png';

interface RegisterFormValues {
  name: string;
  email: string;
  password: string;
  confirmPassword: string;
}

const RegisterSchema = Yup.object().shape({
  name: Yup.string().required('Kullanıcı adı zorunlu'),
  email: Yup.string().email('Geçersiz email').required('Email zorunlu'),
  password: Yup.string().min(6, 'Şifre en az 6 karakter olmalı').required('Şifre zorunlu'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Şifreler eşleşmiyor')
    .required('Şifre tekrarı zorunlu'),
});

export const Register: React.FC = () => {
  const { userStore, uiStore } = useStore();
  const navigate = useNavigate();

  const handleSubmit = async (values: RegisterFormValues) => {
    try {
      const { confirmPassword, ...registerData } = values;
      uiStore.setLoading(true);
      const response: any = await userStore.register({
        username: values.name,
        email: values.email,
        password: values.password,
      });
      uiStore.setLoading(false);
      if (!response.error && response.value) {
        toast.success(response.message || 'Kayıt işlemi başarılı');
        navigate('/login');
      } else {
        toast.error(response.message || 'Kayıt işlemi başarısız');
      }
    } catch (error) {
      uiStore.setLoading(false);
      toast.error('Kayıt işlemi sırasında bir hata oluştu');
    }
  };

  return (
    <div className={styles.container}>
      <img src={KaldenLogo} alt="Kalden Logo" className={styles.logo} />
      <div className={styles.formWrapper}>
        <h1 className={styles.title}>Kayıt Ol</h1>
        <Formik
          initialValues={{
            name: '',
            email: '',
            password: '',
            confirmPassword: '',
          }}
          validationSchema={RegisterSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className={styles.form}>
              <FormikTextField
                name="name"
                label="Kullanıcı Adı"
                placeholder="Kullanıcı Adı Giriniz"
              />
              <FormikTextField
                name="email"
                label="Email"
                type="email"
                placeholder="Email adresinizi giriniz"
              />
              <FormikTextField
                name="password"
                label="Şifre"
                type="password"
                placeholder="Şifrenizi giriniz"
              />
              <FormikTextField
                name="confirmPassword"
                label="Şifre Tekrarı"
                type="password"
                placeholder="Şifrenizi tekrar giriniz"
              />
              <button type="submit" className={styles.submitButton} disabled={isSubmitting}>
                {isSubmitting ? 'Kaydediliyor...' : 'Kayıt Ol'}
              </button>
              <div className={styles.loginLink}>
                Zaten hesabınız var mı? <Link to="/login">Giriş Yap</Link>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
